import * as React from 'react';
import './OrgChart.scss';
import styled from 'styled-components';
import Avatar from '@material-ui/core/Avatar';
import { UserEntity } from '../../../store/entities/state';
import { useHistory } from 'react-router';

const NodeCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacer-XS);
    padding: var(--spacer-S);
    border: var(--border-thin) solid var(--appLigthGrey);
    border-radius: 8px;
    background: white;
    min-width: 90px;
    max-width: 150px;
    transition: border-color 0.15s, background 0.15s;

    &:hover {
        border-color: var(--appBlue);
        background: var(--bg-hover-light);
    }
`;

const NodeName = styled.span`
    font-weight: 500;
    color: var(--text-body);
    font-size: 0.875rem;
    text-align: center;
    word-break: break-word;
`;

const OrgChartNode: React.FC<{ user: UserEntity; users: UserEntity[]; onClose: () => void }> = ({ user, users, onClose }) => {
    const history = useHistory();
    const children = users.filter(u => u.managerId === user.id);

    return (
        <li>
            <a onClick={() => { history.push({ search: `?id=${user.id}` }); onClose(); }} style={{ display: 'block', textDecoration: 'none', color: 'inherit' }}>
                <NodeCard>
                    <Avatar
                        src={user.photoUrl || undefined}
                        style={{ width: 40, height: 40, fontSize: '1rem' }}
                    >
                        {(user.name || user.username || '').charAt(0).toUpperCase()}
                    </Avatar>
                    <NodeName>{user.name || user.username}</NodeName>
                </NodeCard>
            </a>
            {children.length > 0 && (
                <ul>
                    {children.map(child => (
                        <OrgChartNode key={child.id} user={child} users={users} onClose={onClose} />
                    ))}
                </ul>
            )}
        </li>
    );
};

export interface OrgChartProps {
    users: UserEntity[];
    onClose: () => void;
}

const OrgChart: React.FC<OrgChartProps> = ({ users, onClose }) => {
    const rootUsers = users.filter(u => !u.managerId || !users.some(m => m.id === u.managerId));

    return (
        <div className="orgChart">
            <ul>
                {rootUsers.map(user => (
                    <OrgChartNode key={user.id} user={user} users={users} onClose={onClose} />
                ))}
            </ul>
        </div>
    );
};

export default OrgChart;
